import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/LabelBadge.svg'

export const IconLabelBadge = IconSVG as IconComponent
